import React from 'react'
import ComponentStyle from '../styles/Components.module.css'

function Wechat() {
  return (
    <div className={`${ComponentStyle.title}`}><h1>Wechat</h1></div>
  )
}

export default Wechat